export const orderStatus = {
    delivery: 'delivery',
    payment: 'payment',
    summary: 'summary',
    placed: 'placed',
};
